import { createFeatureSelector, createSelector } from '@ngrx/store';
import { fromUserPermissionList } from '../reducers';
import { getAllApplicationItems } from './application.selectors';
import { ApplicationApiConstants } from '../application-api-config';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
export const getUserPermissionListRootState = createFeatureSelector('userPermissionList');
export const getUserPermissionListState = createSelector(getUserPermissionListRootState, (state) => state);
const userPermissionListSelectors = fromUserPermissionList.userPermissionListAdapter.getSelectors(getUserPermissionListState);
export const getAllUserPermissionListItems = userPermissionListSelectors.selectAll;
export const getUserPermissionListEntities = userPermissionListSelectors.selectEntities;
export const getUserPermissionListLoading = createSelector(getUserPermissionListState, fromUserPermissionList.getUserPermissionListLoading);
/**
 * Selector to return the permission list for the current user
 */
export const getCurrentUserPermissionList = createSelector(getUserPermissionListEntities, authSelectors.getUserId, (userPermissionListEntities, userId) => {
    if (userId) {
        return userPermissionListEntities[userId];
    }
    return undefined;
});
/**
 * Selector to return if the current users permissions list has been loaded
 */
export const getUserPermissionListLoaded = createSelector(getCurrentUserPermissionList, (permList) => !!permList);
export const getActiveApplicationName = createSelector(() => ApplicationApiConstants.activeAppName);
export const getActiveApplicationId = createSelector(getActiveApplicationName, (appName) => (appName || '').replace(' ', '-').toLowerCase());
/**
 * Selector to return the applications that the user can access and set the active application
 */
export const getActiveApplication = createSelector(getCurrentUserPermissionList, getAllApplicationItems, (userPermListEntity, applications) => {
    const activeAppName = ApplicationApiConstants.activeAppName;
    let activeApp;
    if (userPermListEntity && userPermListEntity.applications && activeAppName) {
        activeApp = userPermListEntity.applications.find((app) => app.name === activeAppName);
    }
    if (!activeApp && applications && activeAppName) {
        activeApp = applications.find((app) => app.name === activeAppName);
    }
    return activeApp;
});
/**
 * Selector to return the applications that the user can access and set the active application
 */
export const getUserApplications = createSelector(getCurrentUserPermissionList, getActiveApplication, (userPermListEntity, activeApplication) => {
    if (userPermListEntity) {
        return (userPermListEntity.applications || [])
            .filter((app) => !(fromUserPermissionList.NON_PRODUCTION_APPS.includes(app.name) &&
            ApplicationApiConstants.production))
            .map((app) => ({ ...app, isActive: app === activeApplication }));
    }
    return [];
});
/**
 * Selector to return the applications that the user can access and set the active application
 */
export const getDisplayableUserApplications = createSelector(getUserApplications, getActiveApplication, (userApps, activeApplication) => {
    const activeAppName = activeApplication ? activeApplication.name : '';
    return userApps.filter((app) => app.name !== activeAppName && !app.comingSoon && !app.hidden);
});
/**
 * Selector to return the applications that the user can access and set the active application
 */
export const getUserAdminApplications = createSelector(getUserApplications, (userApplications) => {
    if (userApplications) {
        return userApplications.filter((app) => {
            if (app) {
                return app.admin;
            }
            return false;
        });
    }
    return [];
});
/**
 * Selector to return the permission that the user can access.
 */
export const getUserPermissions = createSelector(getCurrentUserPermissionList, (userPermListEntity) => {
    if (userPermListEntity) {
        return userPermListEntity.permissions;
    }
    return [];
});
/**
 * Selector to return is the user has any available permission(s).
 */
export const hasUserPermission = createSelector(getCurrentUserPermissionList, getUserApplications, (userPermListEntity, userApplications) => {
    if (userPermListEntity) {
        return ((userPermListEntity.permissions.length > 0 ||
            userApplications.filter((application) => application.admin).length > 0) &&
            userApplications.filter((application) => application.name === ApplicationApiConstants.activeAppName).length > 0);
    }
    return false;
});
//# sourceMappingURL=user-permission-list.selectors.js.map